<button class="btn btn-sm btn-link"
        (click)="onRetry()">Retry all</button>